import { Grid } from "antd";
import React from "react";
import { H3 } from "../NormalFonts";
import { TitleProps } from "./data";
import styles from "./styleModule";

const Title: React.FC<TitleProps> = ({
  title = "Title",
  subtitle = "Subtitle",
  customTitleContainer = "",
}) => {
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <div className={`${styles.titleContainer} ${customTitleContainer}`}>
      <H3
        className={styles.title}
        weight="heavy"
        color="var(--primary)"
        style={{
          letterSpacing: "9.6px",
          fontSize: screens.md ? "48px" : "24px",
        }}
      >
        {title}
      </H3>
    </div>
  );
};

export default Title;
